import { Button, Box, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import GridSkeleton from "../components/GridSkeleton";
import { useFetchData } from "../hooks/useFetchData";
import { useParams, Navigate } from "react-router-dom";

export const DashboardToolbarSelect = () => {
  const { dashboard: pDashboard, partner: pPartner} = useParams();
  let navigate = useNavigate()
  const partnerApiUrl = `partner/${pPartner}`;
  const endPointURL = `${partnerApiUrl}/dashboards`;

  const { status, data } = useFetchData({
    endpoint: endPointURL,
  });

  const handleDashboardSelect = (e) => {
      navigate(`/${pPartner}/${e.target.value}`);
  };

  if (status === "rejected") {
    return <Navigate to="/error" />;
  }

  if (status === "unauthorized") {
    return <Navigate to="/login" />;
  }

  return (
    <>
        {status === "loading" ? (
            <GridSkeleton rows={1} cols={3} />
        ) : (
            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                {data.map((dashboard) => (
                <Button
                    key={dashboard.dashboard_name}
                    onClick={handleDashboardSelect}
                    value={dashboard.dashboard_name}
                    sx={{ color: 'white', display: 'block', fontWeight: dashboard.dashboard_name === pDashboard ? 'bold' : ''}}
                >
                    {dashboard.dashboard_label}
                </Button>
                ))}
            </Box>
        )}
    </>
  );
};